import { useQuery } from "@tanstack/react-query";

import { useAuthenticatedRequest } from "./useRequests";
import { UserDashboard } from "models/accountSummary";

const useUserSummary = () => {
    const getData = useAuthenticatedRequest<UserDashboard>({
        url: `/dashboard/customer`,
        method: "GET",
    });

    return useQuery(["userSummary"], getData);
};

export default useUserSummary;
